module.exports = __webpack_public_path__ + "img/hz_03.0a53b294.png";